import type { ActivityCompletionStatusFilter } from '@cobliteam/api-lib';
import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';

interface ActivityStatusTitleProps {
  size: 'sm' | 'md';
  selectedStatus: ActivityCompletionStatusFilter[];
}

const ActivityStatusTitle = ({ size, selectedStatus }: ActivityStatusTitleProps) => {
  const { t } = useTranslation('multiselects');

  const countLabel = selectedStatus?.length > 0 ? `(${selectedStatus.length})` : '';

  return (
    <Button size={size} variant='ghost' startIcon={<Icon name='filter' />}>
      {t('activity_status.title')} {countLabel}
    </Button>
  );
};

export default ActivityStatusTitle;
